import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import NodoCircuito from './NodoCircuito';
import { nombreComprobante } from '../textosComprobante';
import { resumenEnlace, verboEnlace } from './armarCircuito';
import colores from '../Bandeja/coloresBandeja';

const useStyles = makeStyles(() => ({
  linea: {
    position: 'relative',
    paddingLeft: '26px',
    maxWidth: '560px',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '8px',
      top: '6px',
      bottom: '6px',
      width: '2px',
      backgroundColor: colores.borde
    }
  },
  item: {
    position: 'relative',
    paddingBottom: '14px',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '-23px',
      top: '12px',
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor: colores.primario,
      border: '2px solid white',
      boxShadow: `0 0 0 1px ${colores.primario}`
    }
  },
  raiz: {
    '&::before': {
      backgroundColor: colores.naranja,
      boxShadow: `0 0 0 1px ${colores.naranja}`
    }
  },
  desde: {
    fontSize: '11px',
    color: colores.tenue,
    marginBottom: '2px'
  }
}));

/** Todos los comprobantes del circuito por fecha, cada uno con lo que descargó. */
const CircuitoLineaTiempo = ({ circuito }) => {
  const classes = useStyles();

  return (
    <div className={classes.linea}>
      {circuito.todos.map((nodo) => {
        const esRaiz = nodo.clave === circuito.raiz.clave;
        const origenes = circuito.origenes(nodo.clave);
        return (
          <div key={nodo.clave} className={`${classes.item} ${esRaiz ? classes.raiz : ''}`}>
            {origenes.length > 0 && (
              <div className={classes.desde}>
                ← {origenes.map((origen) => `${verboEnlace(origen.enlace)} ${nombreComprobante(origen.nodo)} (${resumenEnlace(origen.enlace)})`).join(', ')}
              </div>
            )}
            <NodoCircuito nodo={nodo} esRaiz={esRaiz} circuito={circuito} />
          </div>
        );
      })}
    </div>
  );
};

export default CircuitoLineaTiempo;
